const PREFIX = "SCHOOL"
const SCHOOL_TYPES = {
  CREATE_SCHOOL: `${PREFIX}/CREATE`,
  UPDATE_SCHOOL: `${PREFIX}/UPDATE`,
  GET_SCHOOL: `${PREFIX}/GET`,
  CLEAR: `${PREFIX}/CLEAR`
}

export default SCHOOL_TYPES
